import { render, staticRenderFns } from "./upsert-item.vue?vue&type=template&id=6e42db7c&scoped=true"
import script from "./upsert-item.vue?vue&type=script&lang=js"
export * from "./upsert-item.vue?vue&type=script&lang=js"
import style0 from "./upsert-item.vue?vue&type=style&index=0&id=6e42db7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42db7c",
  null
  
)

export default component.exports